<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      tmplData: null,
      baseForm: {
        billTitleSelectOptions: [],
        form: [
          {
            label: '字段',
            value: 'billTitleSelect',
            type: 'checkbox',
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        this.baseForm.billTitleSelectOptions.forEach((item) => {
          if (formData.billTitleSelect.indexOf(item.value) === -1) {
            item.isSelect = 0;
          } else {
            item.isSelect = 1;
          }
        });
        formData = this.baseForm.billTitleSelectOptions;
      }
      return formData;
    },

    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        formData = {
          cmTemplateFieldList: JSON.stringify(formData),
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return {
        items: res,
      };
    },
    async init (data = {items: []}) {
      const billTitleSelect = [];
      data.items.forEach((item) => {
        if (item.isSelect) {
          billTitleSelect.push(item.id);
        }
        if (item.isCancel === 0) {
          item.disabled = true;
        }
        item.label = item.fieldDesc;
        item.value = item.id;
      });
      this.baseForm.billTitleSelectOptions = data.items;
      this.$refs.baseForm.setVal('billTitleSelect', billTitleSelect);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
